export interface AddDemoRecordPopupProps {
  author_id: number;
  language: string;
  onClose: () => void;
  onSuccess: Function;
  show: boolean;
}

export interface FormType {
  author_id: number;
  description: string;
  documents_link: string;
  name: string;
  record_link: string;
  slide_link: string;
}

export const initForm: FormType = {
  author_id: 0,
  description: "",
  documents_link: "",
  name: "",
  record_link: "",
  slide_link: "",
};
